import { render, staticRenderFns } from "./ReviewerFeedback.vue?vue&type=template&id=4434c8f9&"
import script from "./ReviewerFeedback.vue?vue&type=script&lang=js&"
export * from "./ReviewerFeedback.vue?vue&type=script&lang=js&"
import style0 from "./ReviewerFeedback.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports